import React from 'react'
import { Box } from '../../ui/box'

interface Props {
    children: React.ReactNode
}

export class TraceDetails extends React.PureComponent<Props> {
    render() {
        return (
            <div className="timeline-info">
                <Box>{this.props.children}</Box>
            </div>
        )
    }
}
